import React, { useState, useEffect } from 'react';
import { useTypedTranslation } from '@app/hooks';
import { FormControl } from '@material-ui/core';
import { PasslyMaskedInput, PasslyTextField } from '@app/components';

interface IProps {
    checkValidation: Function;
    patchData: string;
}

interface IValidation {
    error: boolean;
    valid: boolean;
}

export const IPSelector = (props: IProps) => {
    const { translation } = useTypedTranslation();
    const { checkValidation, patchData } = props;
    const ipMaskRegex: RegExp = /[0-9\.,\/ -]/;

    const ipBaseRegex: RegExp = /^(((((\b25[0-5]|\b2[0-4][0-9]|\b[01]?[0-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3})(\/(32|[0-9]|[0-2][0-9]|[0-3][0-2]))?)|((\b25[0-5]|\b2[0-4][0-9]|\b[01]?[0-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}\-(\b25[0-5]|\b2[0-4][0-9]|\b[01]?[0-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}))(\,(\s+)?)?){1,}$/;

    const handlePatchData = (): string => {
        return typeof patchData === 'string' ? patchData : '';
    };

    const [validation, setValidation] = useState<IValidation>({error: false, valid: false});
    const [ip, setIp] = useState<string>('');

    useEffect(() => {
        let ipValue = handlePatchData();
        if (ipValue !== '') {
            validateIp(ipValue);
        }
    }, []);

    const handleInputChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        const value = event.target.value as string;
        validateIp(value);
    };

    const validateIp = (value: string) => {
        ipBaseRegex.test(value)
            ? setValidation({ error: false, valid: true })
            : setValidation({ error: true, valid: false });
        setIp(value);
    };

    useEffect(() => {
        if (validation.valid && ip !== '') {
            checkValidation(true, ip);
        } else {
            checkValidation(false, null);
        }
    }, [validation, ip]);

    return (
        <div className='ipSelector'>
            <FormControl>
                <PasslyTextField
                    id='ip-selector'
                    label={'IP_RANGE'}
                    value={ip}
                    onChange={handleInputChange}
                    InputProps={{
                        inputComponent: PasslyMaskedInput,
                        inputProps: {
                            maskSize: 5000,
                            maskRegex: ipMaskRegex
                        },
                    }}
                    error={validation.error}
                    helperText={validation.error ? translation('INVALID_IP_RANGE') : undefined}
                />
            </FormControl>
        </div>
    );
};
